import Popup from "../../../components/Popup";
import { useDispatch, useSelector } from "react-redux";
import {
    closeShipmentEventsPopup,
    selectEventsShipment,
    selectEventsShipmentTrc,
    selectShipmentEventsError,
    selectShipmentEventsPopupState,
    selectShipmentEventsStatus,
    selectShipmentEventsUploading,
    setUploadingToFalse,
    uploadEvents,
} from "./shipmentEventsSlice";
import ShipmentEvent from "./ShipmentEvent";
import { useEffect, useMemo } from "react";
import GreenSpinner from "../../../components/loaders/GreenSpinner";
import { useTranslation } from "react-i18next";
import { getEventsAddressPostfix } from "../../shipment/EditShipment/editShipmentUtils";

const ShipmentEventsPopup = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();

    const popupState = useSelector(selectShipmentEventsPopupState);
    const shipmentTrc = useSelector(selectEventsShipmentTrc);
    const eventsStatus = useSelector(selectShipmentEventsStatus);
    const eventsError = useSelector(selectShipmentEventsError);
    const uploading = useSelector(selectShipmentEventsUploading);

    const eventsShipment = useSelector(selectEventsShipment);

    const handlePopupClose = () => {
        dispatch(closeShipmentEventsPopup());
    };

    useEffect(() => {
        if (uploading) {
            dispatch(uploadEvents(shipmentTrc));
            dispatch(setUploadingToFalse());
        }
    }, [dispatch, shipmentTrc, uploading]);

    const fromAddress = useMemo(() => {
        if (eventsStatus === "fulfilled" && eventsShipment) {
            return eventsShipment[
                "from_address_" + getEventsAddressPostfix(i18n.language)
            ];
        }

        return "";
    }, [eventsShipment, eventsStatus, i18n.language]);

    const toAddress = useMemo(() => {
        if (eventsStatus === "fulfilled" && eventsShipment) {
            return eventsShipment[
                "to_address_" + getEventsAddressPostfix(i18n.language)
            ];
        }

        return "";
    }, [eventsShipment, eventsStatus, i18n.language]);

    return (
        <Popup opened={popupState.opened} closeCallback={handlePopupClose}>
            {uploading && (
                <div className="text-blue-500">
                    Loading...
                    <GreenSpinner />
                </div>
            )}

            {!uploading && (
                <>
                    {eventsStatus === "fulfilled" && (
                        <>
                            <div className="text-2xl text-emerald-600 text-left w-full mb-4">
                            {t("shipments.shipment_events.popup.title")} <div className="text-lg">{shipmentTrc}</div> 
                            </div>
                            <div className="flex flex-col items-start text-left mb-4">
                                <span>
                                    <span className="font-semibold">
                                        {t(
                                            "shipments.shipment_events.popup.from"
                                        )}
                                        :{" "}
                                    </span>
                                    {fromAddress}
                                </span>
                                <span>
                                    <span className="font-semibold">
                                        {t(
                                            "shipments.shipment_events.popup.to"
                                        )}
                                        :{" "}
                                    </span>
                                    {toAddress}
                                </span>
                            </div>
                            <div className="flex flex-col gap-4">
                                {eventsShipment?.events?.map((event, idx) => (
                                    <ShipmentEvent key={idx} event={event} />
                                ))}
                            </div>
                        </>
                    )}

                    {eventsStatus === "rejected" && (
                        <div className="text-red-500" style={{padding: "0 35px"}}>
                            {eventsError === "shipment_not_found"
                                ? t(
                                      "shipments.shipment_events.shipment_not_found"
                                  )
                                : t(eventsError)}
                        </div>
                    )}
                </>
            )}
        </Popup>
    );
};

export default ShipmentEventsPopup;
